import { ModulesUiRegistryEntry } from '../../../contexts'
import { resolveProductApplicationSliderModuleContent } from '../ProductApplicationSlider.helper'

export const productApplicationSliderModule: ModulesUiRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "ui/core/product-application-slider" */ './ProductApplicationSlider.ui.vue'
  ),
  resolver: resolveProductApplicationSliderModuleContent
}
